import React from 'react';

const StopTimingManager = ({ 
  stop, 
  timeSlots = [],
  onTimingUpdate, 
  disabled = false,
  stopIndex
}) => {
  
  const getTimingForSlot = (slotSequence) => {
    if (!stop.timings) return { arrivalTime: '', departureTime: '' };
    const timing = stop.timings.find(t => t.timeSlotSequence === slotSequence);
    return timing || { arrivalTime: '', departureTime: '' };
  };

  const updateTiming = (slotSequence, field, value) => {
    let updatedTimings = [...(stop.timings || [])];
    const existingIndex = updatedTimings.findIndex(t => t.timeSlotSequence === slotSequence);
    
    if (existingIndex !== -1) {
      updatedTimings[existingIndex] = { 
        ...updatedTimings[existingIndex], 
        [field]: value,
        timeSlotSequence: slotSequence,
        sequence: stop.sequence || stopIndex + 1
      };
    } else {
      updatedTimings.push({
        timeSlotSequence: slotSequence,
        sequence: stop.sequence || stopIndex + 1,
        arrivalTime: field === 'arrivalTime' ? value : '',
        departureTime: field === 'departureTime' ? value : ''
      });
    }
    
    onTimingUpdate(stop.sequence || stopIndex + 1, updatedTimings);
  };

  if (!timeSlots || timeSlots.length === 0) {
    return (
      <div style={{ 
        fontSize: '12px', 
        color: '#999', 
        padding: '12px',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px'
      }}>
        Please set number of trips in Origin section first
      </div>
    );
  }

  return (
    <div className="stop-timing-manager" style={{ marginTop: '10px', marginBottom: '15px' }}>
      <div style={{ 
        fontSize: '12px', 
        fontWeight: '500', 
        marginBottom: '12px', 
        color: '#495057',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <span>⏰ Timings for each trip:</span>
        <span style={{ 
          fontSize: '11px', 
          color: '#6c757d',
          backgroundColor: '#e9ecef',
          padding: '2px 8px',
          borderRadius: '12px'
        }}>
          {timeSlots.length} trip{timeSlots.length !== 1 ? 's' : ''} per day
        </span>
      </div>
      
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '12px',
        maxHeight: '400px',
        overflowY: 'auto',
        paddingRight: '4px'
      }}>
        {timeSlots.map((slot, idx) => {
          const timing = getTimingForSlot(slot.sequence);
          return (
            <div key={slot.sequence} style={{
              display: 'flex',
              gap: '12px',
              alignItems: 'center',
              padding: '12px',
              backgroundColor: idx % 2 === 0 ? '#f8f9fa' : '#ffffff',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                fontWeight: '600', 
                minWidth: '70px', 
                fontSize: '13px',
                color: '#007bff'
              }}>
                🚌 Trip #{slot.sequence}:
              </div>
              
              <div className="form-group" style={{ flex: 1, minWidth: '140px', marginBottom: 0 }}>
                <label style={{ fontSize: '11px', marginBottom: '2px', display: 'block', color: '#666' }}>
                  🕒 Arrival Time
                </label>
                <input
                  type="time"
                  value={timing.arrivalTime}
                  onChange={(e) => updateTiming(slot.sequence, 'arrivalTime', e.target.value)}
                  placeholder="--:--"
                  className="form-input"
                  style={{ 
                    fontSize: '13px', 
                    padding: '8px 10px',
                    borderColor: timing.arrivalTime ? '#28a745' : '#ffc107',
                    backgroundColor: timing.arrivalTime ? '#fff' : '#fffbf0'
                  }}
                  disabled={disabled}
                />
              </div>
              
              <div className="form-group" style={{ flex: 1, minWidth: '140px', marginBottom: 0 }}>
                <label style={{ fontSize: '11px', marginBottom: '2px', display: 'block', color: '#666' }}>
                  🚀 Departure Time
                </label>
                <input
                  type="time"
                  value={timing.departureTime}
                  onChange={(e) => updateTiming(slot.sequence, 'departureTime', e.target.value)}
                  placeholder="--:--"
                  className="form-input"
                  style={{ 
                    fontSize: '13px', 
                    padding: '8px 10px',
                    borderColor: timing.departureTime ? '#28a745' : '#ffc107',
                    backgroundColor: timing.departureTime ? '#fff' : '#fffbf0'
                  }}
                  disabled={disabled}
                />
              </div>
              
             
            </div>
          );
        })}
      </div>
      
      <div style={{ 
        fontSize: '11px', 
        color: '#6c757d', 
        marginTop: '10px',
        padding: '8px',
        textAlign: 'center',
        backgroundColor: '#e7f3ff',
        borderRadius: '6px'
      }}>
        💡 Tip: Set arrival and departure times for each trip separately
      </div>
    </div>
  );
};

export default StopTimingManager;